import React from "react";
import UnderConstruction from "../components/UnderConstruction";

const PressPage = () => {
  return (
    <UnderConstruction 
      title="Press Room"
      description="Access press releases, company announcements, executive bios, and media resources for journalists and industry analysts."
      expectedLaunch="Coming Soon"
    />
  );
};

export default PressPage;